module.exports = __webpack_public_path__ + "img/perquisites.61501d4e.svg";